import labels from './labels';
import buttons from './buttons';
import options from './options';
import snackbar from './snackbar';
import errorCodes from './errorCodes';

export default { ...labels, ...options, ...snackbar, ...buttons, ...errorCodes };
